import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"
import { FaCheckCircle } from "react-icons/fa"
import { GoDash } from "react-icons/go"


import Layout from "../components/layout"
import SEO from "../components/seo"
import Scroller from "../components/scroller"
import PortfolioModal from "../components/portfolio/modal"
import PortfolioCarousel from "../components/portfolio/carousel"

export default class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    Scroller.handleAnchorScroll = Scroller.handleAnchorScroll.bind(this)
    this.state = {
      modalShow: false,
      modalCurrent: 0
    }
    this.handlePortfolioClick = this.handlePortfolioClick.bind(this);
    this.setModal = this.setModal.bind(this);
  }

  handlePortfolioClick(index, e) {
    e.preventDefault();
    this.setModal(true, index);
  }

  setModal(isShown, current) {
    this.setState({
      modalShow: isShown,
      modalCurrent: current
    });
  }

  render() {
    return (
      <Layout>
        <SEO title="Home" />
        <section className="page-section bg-primary" id="about">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <h2 className="text-white mt-0">Análisis de Handicapping directo a tu correo</h2>
                <hr className="divider light my-4" />
                <p className="text-white-50 mb-4">Termometro Hipico, a traves de su interfaz simple y moderna te permite activar tu suscripción en poco tiempo y con facilidad. Una vez inscrito, recibirás correos con nuestros análisis antes del dia de la carrera de acuerdo a tu plan</p>
                <a className="btn btn-light btn-xl js-scroll-trigger" href="#start"
                  onClick={Scroller.handleAnchorScroll}>Comenzar Gratis</a>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section" id="services">
          <div className="container">
            <h2 className="text-center mt-0">A su servicio</h2>
            <hr className="divider my-4" />
            <div className="row">
              <div className="col-lg-3 col-md-6 text-center">
                <div className="mt-5">
                  <i className="fas fa-4x fa-gem text-primary mb-4"></i>
                  <h3 className="h4 mb-2">Planes Premium</h3>
                  <p className="text-muted mb-0">Tenemos un plan para cada necesidad. Desde totalmente gratis hasta premium.</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 text-center">
                <div className="mt-5">
                  <i className="fas fa-4x fa-laptop-code text-primary mb-4"></i>
                  <h3 className="h4 mb-2">Plataforma Moderna</h3>
                  <p className="text-muted mb-0">Nuestra plataforma funciona a base de correos para que puedas acceder a tus graficos desde cualquier dispositivo.</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 text-center">
                <div className="mt-5">
                  <i className="fas fa-4x fa-globe text-primary mb-4"></i>
                  <h3 className="h4 mb-2">Alcance Global</h3>
                  <p className="text-muted mb-0">Al permanecer en internet, nuestros servicios pueden ser consumidos desde cualquier parte del mundo.</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 text-center">
                <div className="mt-5">
                  <i className="fas fa-4x fa-heart text-primary mb-4"></i>
                  <h3 className="h4 mb-2">Hecho por hipicos, para hipicos</h3>
                  <p className="text-muted mb-0">Nuestra pasión por las carreras nos mueve.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section id="portfolio">
          <div className="container-fluid p-0">
            <div className="row no-gutters">
              <div className="col-lg-4 col-sm-6">
                <a className="portfolio-box" href="img/portfolio/fullsize/1.jpg" onClick={this.handlePortfolioClick.bind(this, 0)}>
                  <Img fluid={this.props.data.images.edges[0].node.childImageSharp.fluid} />
                  <div className="portfolio-box-caption">
                    <div className="project-category text-white-50">
                      Grafico
                    </div>
                    <div className="project-name">
                      Enero 25
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-sm-6">
                <a className="portfolio-box" href="img/portfolio/fullsize/2.jpg" onClick={this.handlePortfolioClick.bind(this, 1)}>
                  <Img fluid={this.props.data.images.edges[1].node.childImageSharp.fluid} />
                  <div className="portfolio-box-caption">
                    <div className="project-category text-white-50">
                      Grafico
                    </div>
                    <div className="project-name">
                      Enero 25
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-sm-6">
                <a className="portfolio-box" href="img/portfolio/fullsize/3.jpg" onClick={this.handlePortfolioClick.bind(this, 2)}>
                  <Img fluid={this.props.data.images.edges[2].node.childImageSharp.fluid} />
                  <div className="portfolio-box-caption">
                    <div className="project-category text-white-50">
                      Grafico
                    </div>
                    <div className="project-name">
                      Enero 25
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-sm-6">
                <a className="portfolio-box" href="images/portfolio/fullsize/4.jpg" onClick={this.handlePortfolioClick.bind(this, 3)}>
                  <Img fluid={this.props.data.images.edges[3].node.childImageSharp.fluid} />
                  <div className="portfolio-box-caption">
                    <div className="project-category text-white-50">
                      Grafico
                    </div>
                    <div className="project-name">
                      Enero 25
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-sm-6">
                <a className="portfolio-box" href="img/portfolio/fullsize/5.jpg" onClick={this.handlePortfolioClick.bind(this, 4)}>
                  <Img fluid={this.props.data.images.edges[4].node.childImageSharp.fluid} />
                  <div className="portfolio-box-caption">
                    <div className="project-category text-white-50">
                      Grafico
                    </div>
                    <div className="project-name">
                      Enero 25
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-sm-6">
                <a className="portfolio-box" href="img/portfolio/fullsize/6.jpg" onClick={this.handlePortfolioClick.bind(this, 5)}>
                  <Img fluid={this.props.data.images.edges[5].node.childImageSharp.fluid} />
                  <div className="portfolio-box-caption p-3">
                    <div className="project-category text-white-50">
                      Grafico
                    </div>
                    <div className="project-name">
                      Enero 25
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section> */}

        <section id="plans" className="page-section bg-dark text-white">
          <div className="container text-center">
            <div className="row text-center justify-content-center">
              <h2 className="mb-4">Planes</h2>
            </div>
            <div className="row justify-content-center align-items-center" style={{ marginBottom: 20 }}>
              <div class="card" style={{ width: 320, height:400, borderRadius: 15, color: "black", marginRight: 20, marginLeft: 20, marginTop: 20 }}>
                <div class="card-body">
                  <h4 class="card-title">Gratis</h4>
                  <h5 class="card-title" style={{marginBottom: 40}}>0.00 usd / mes</h5>
                  <p className="text-left"><span><FaCheckCircle style={{ color: "green", marginRight: 10 }} /></span>Un grafico por dia analizado</p>
                  <p className="text-left"><span><FaCheckCircle style={{ color: "green", marginRight: 10 }} /></span>Membresia ilimitada</p>
                  <p className="text-left"><span><GoDash style={{ color: "red", marginRight: 10 }} /></span>Graficos ilimitados</p>
                  <p className="text-left"><span><GoDash style={{ color: "red", marginRight: 10 }} /></span>Acceso al grupo de discución</p>
                  <p className="text-left"><span><GoDash style={{ color: "red", marginRight: 10 }} /></span>Análisis a fondo</p>
                </div>
              </div>
              <div class="card" style={{ width: 320, height:400, borderRadius: 15, color: "black", marginRight: 20, marginLeft: 20, marginTop: 20 }}>
                <div class="card-body">
                  <h4 class="card-title">Estándar</h4>
                  <h5 class="card-title" style={{marginBottom: 40}}>8.99 usd / mes</h5>
                  <p className="text-left"><span><FaCheckCircle style={{ color: "green", marginRight: 10 }} /></span>Tres graficos por dia analizado</p>
                  <p className="text-left"><span><FaCheckCircle style={{ color: "green", marginRight: 10 }} /></span>Membresia ilimitada</p>
                  <p className="text-left"><span><GoDash style={{ color: "red", marginRight: 10 }} /></span>Graficos ilimitados</p>
                  <p className="text-left"><span><GoDash style={{ color: "red", marginRight: 10 }} /></span>Acceos al grupo de discución</p>
                  <p className="text-left"><span><GoDash style={{ color: "red", marginRight: 10 }} /></span>Análisis a fondo</p>
                </div>
              </div>
              <div class="card" style={{ width: 320, height:400, borderRadius: 15, color: "black", marginRight: 20, marginLeft: 20, marginTop: 20 }}>
                <div class="card-body">
                  <h4 class="card-title">Premium</h4>
                  <h5 class="card-title" style={{marginBottom: 40}}>12.99 usd / mes</h5>
                  <p className="text-left"><span><FaCheckCircle style={{ color: "green", marginRight: 10 }} /></span>Todos los graficos</p>
                  <p className="text-left"><span><FaCheckCircle style={{ color: "green", marginRight: 10 }} /></span>Membresia ilimitada</p>
                  <p className="text-left"><span><FaCheckCircle style={{ color: "green", marginRight: 10 }} /></span>Graficos ilimitados</p>
                  <p className="text-left"><span><FaCheckCircle style={{ color: "green", marginRight: 10 }} /></span>Membresia ilimitada</p>
                  <p className="text-left"><span><FaCheckCircle style={{ color: "green", marginRight: 10 }} /></span>Acceso al grupo de discución</p>
                  <p className="text-left"><span><FaCheckCircle style={{ color: "green", marginRight: 10 }} /></span>Análisis a fondo</p>
                </div>
              </div>
            </div>
            <a className="btn btn-light btn-xl" href="#start">Comenzar Gratis</a>
          </div>
        </section>

        <section id="start" className="page-section" id="contact">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <h2 className="mt-0">Cominza Gratis</h2>
                <hr className="divider my-4" />
                <p className="text-muted mb-5">Para comenzar a recibir nuestros análisis, escriba un correo a la siguiente direccion de correo electronico presentandose y expresando cual de los <a href="#plans">planes</a> le interesa.</p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg mr-auto text-center">
                <i className="fas fa-envelope fa-3x mb-3 text-muted"></i>
                <a className="d-block" href="mailto:termometrohipico@outlook.com">termometrohipico@outlook.com</a>
              </div>
            </div>
          </div>
        </section>
        <PortfolioModal show={this.state.modalShow} onHide={() => this.setModal(false, 0)}>
          <PortfolioCarousel images={this.props.data.images.edges} current={this.state.modalCurrent} />
        </PortfolioModal>
      </Layout>
    )
  }
}


export const imageData = graphql`
  query {
          images: allFile(filter: {relativePath: {glob: "portfolio/fullsize/*.jpg"}}, sort: {fields: name}) {
          edges {
          node {
          childImageSharp {
          fluid {
          ...GatsbyImageSharpFluid
        }
        }
      }
    }
  }
}
`
